import { tagsToOptions } from './formatters'

export const tagListSelector = (state) => state.tags.list
export const tagOptionsSelector = (state) =>
  tagsToOptions(tagListSelector(state))
export const tagExpiresAtSelector = (state) => state.tags.expiresAt
